/**
 * Const values to show on this component
 */
export const SelectorLabels = {
    noItems: 'No options to show',
};
